import ActionCard from './ActionCard';
export type { ActionCardProps } from './ActionCard.types';

export default ActionCard;
